import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../../../components/buttons/Button";
import Content from "../../../components/Content";
import InputField from "../../../components/Inputs/InputField";
import * as serviceApi from "../../../hooks/useServiceData";
import Check from "../../../components/Inputs/Check";
import { useSnackbar } from "notistack";

export const ServiceGroupEditView = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [edited, setEdited] = useState(false);

  const serviceGroupParam = useParams();
  const serviceGroupId = serviceGroupParam.id;

  const [name, setName] = useState("");
  const [ownerId, setOwnerId] = useState("");
  const [cost, setCost] = useState("");
  const [isActive, setIsActive] = useState(true);

  const { data } = serviceApi.GetServiceGroup(serviceGroupId);
  const { mutate } = serviceApi.UpdateServiceGroup();

  useEffect(() => {
    if (data?.data) {
      setName(data?.data.name);
      setOwnerId(data?.data.owner_id);
      setCost(data?.data.cost);
      setIsActive(data?.data.isActive === 1 ? true : false);
    }
  }, [data]);

  const updateServiceGroup = () => {
    let _serviceGroup = {};

    _serviceGroup.serviceGroupId = data?.data.id;
    _serviceGroup.name = name;
    _serviceGroup.owner_id = ownerId;
    _serviceGroup.cost = cost;
    _serviceGroup.isActive = isActive;

    mutate(_serviceGroup, {
      onSuccess: () => {
        enqueueSnackbar("Tjänstegrupp uppdaterad.", {
          variant: "success",
        });
        navigate(`/registry/servicegroup/details/${serviceGroupId}`);
      },
      onError: (error) => {
        enqueueSnackbar("Tjänstegrupp kunde inte uppdateras.", {
          variant: "success",
        });
        console.log("ERROR UPDATING SERVICEGROUP: ", error);
      },
    });
  };

  return (
    <>
      <Content title={`${data?.data.name}`}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            updateServiceGroup();
          }}
          className="container"
          style={{ width: "100%" }}
        >
          <InputField
            required
            label={"Tjänstegruppens namn"}
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              setEdited(true);
            }}
          />
          <InputField
            required
            label={"Tjänstegruppens id"}
            value={ownerId}
            onChange={(e) => {
              setOwnerId(e.target.value);
              setEdited(true);
            }}
          />
          <InputField
            required
            type="number"
            label={"Tjänstegruppens kostnad"}
            value={cost}
            onChange={(e) => {
              setCost(e.target.value);
              setEdited(true);
            }}
          />
          <Check
            color="success"
            label="Aktiv Tjänstegrupp"
            checked={isActive}
            onChange={(e) => {
              setIsActive(e.target.checked);
              setEdited(true);
            }}
          />

          <div className="rightAlign-button-container">
            <Button
              className={edited ? "button-pulse" : undefined}
              disabled={!edited}
              type="submit"
              color="success"
            >
              Spara
            </Button>
          </div>
        </form>
      </Content>
    </>
  );
};
